"use client"

import type React from "react"
import type { ILesson } from "@/lib/types/course/lesson"
import type { CourseDetail } from "@/lib/types/course/detail"
import CourseActions from "./CourseActions"
import CourseFeatures from "./CourseFeatures"
import MoreDocument from "./lesson/moreDocument"

interface IncludeCourseProps {
	course: CourseDetail
	className?: string
}

const IncludeCourse: React.FC<IncludeCourseProps> = ({
	course,
	className = "",
}) => {
	return (
		<div className={`space-y-2 ${className}`}>
			<div className="static my-2 overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg">
				<div className="hidden md:block">
					<CourseActions course={course} />
				</div>
				<CourseFeatures course={course} />
			</div>
			<MoreDocument moreDocument={course.more_document} />
		</div>
	)
}

export default IncludeCourse
